import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import ImageViewer from 'components/ImageViewer'

const BasicInfo = ({
  id,
  firstName,
  lastName,
  bio,
  yearsPlayed,
  handicap,
  holeInOnes,
  profileImage,
  onImageUpload,
  defaultImage,
  gender,
  phone,
  gmail,
  onChange,
  children,
}) => (
  <div className="fieldset-wrap">
    <fieldset className="fieldset">
      <legend className="legend">
        1. Profile<br />
        <small>
          Fill in all the basic information below to build
          your profile on Birdietime.
        </small>
      </legend>
      <Row className="form--row">
        <Col xs={12} md={6}>
          <div className="form-group">
            <label className="label" htmlFor="firstname">
              Firstname
            </label>
            <input disabled type="text" id="firstname" name="firstname" value={firstName} />
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div className="form-group">
            <label className="label" htmlFor="lastname">
              Lastname
            </label>
            <input disabled type="text" id="lastname" name="lastname" value={lastName} />
          </div>
        </Col>
      </Row>
      <Row className="form--row">
        <Col xs={12} md={6}>
          <div className="form-group">
            <label className="label" htmlFor="phone">
              Phone
            </label>
            <input required type="tel" onChange={onChange} id="phone" name="phone" value={phone} />
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div className="form-group">
            <label className="label" htmlFor="gmail">
              Email (optional)
            </label>
            <input type="email" onChange={onChange} id="gmail" name="gmail" value={gmail} />
          </div>
        </Col>
      </Row>
      <Row className="form--row">
        <Col xs={12}>
          <div className="form-group">
            <label className="label" htmlFor="bio">
              Description of the pro
            </label>
            <textarea className="textarea--big" onChange={onChange} id="bio" name="bio" value={bio} />
          </div>
        </Col>
      </Row>
      <Row className="form--row">
        <Col xs={12}>
          <div className="form-group">
            <ImageViewer
              id={id}
              fileKey={profileImage}
              prepend={`${lastName}_${firstName}`}
              onChange={onImageUpload}
              genger={gender}
              defaultImage={defaultImage}
              setDefaultImage={onChange}
            />
          </div>
        </Col>
      </Row>
      <Row className="form--row">
        <Col xs={12}>
          <div className="form-group">
            <label className="label" htmlFor="yearsPlayed">Years played as a Pro</label>
            <br />
            <input required type="number" onChange={onChange} id="yearsPlayed" name="yearsPlayed" value={yearsPlayed} />
          </div>
        </Col>
      </Row>
      <Row className="form--row">
        <Col xs={12}>
          <div className="form-group">
            <label className="label" htmlFor="handicap">Handicap before turning Pro</label>
            <br />
            <input required type="tel" onChange={onChange} id="handicap" name="handicap" value={handicap} />
          </div>
        </Col>
      </Row>
      <Row className="form--row">
        <Col xs={12}>
          <div className="form-group">
            <label className="label" htmlFor="holeInOnes">Hole in Ones</label>
            <br />
            <input required type="number" onChange={onChange} id="holeInOnes" name="holeInOnes" value={holeInOnes} />
          </div>
        </Col>
      </Row>
      {children}
    </fieldset>
  </div>
)

export default BasicInfo



// WEBPACK FOOTER //
// ./src/components/BasicInfo/BasicInfo.js